exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bubble[data-v-97280da4]{display:inline-block;padding:0 .25rem;height:.8rem;line-height:.8rem;text-align:center;border-radius:.8rem;font-family:Helvetica;font-weight:700;font-size:.5rem;color:#fff;background:-webkit-gradient(linear,left top,right top,from(#fc9153),to(#f01414));background:-webkit-linear-gradient(left,#fc9153,#f01414);background:linear-gradient(90deg,#fc9153,#f01414)}", ""]);

// exports
